import { NgModule } from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './core/guards';
import {ContactPageComponent} from './contact-page/contact-page.component';
import {ContactPageModule} from './contact-page/contact-page.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'verification',
    loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('./contact-page/contact-page.module').then(m => m.ContactPageModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      config
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
